import React, { useEffect } from 'react';
import styled from 'styled-components/macro';
import { Field } from 'formik';
import Select from '../../Common/Select';
import { ReactComponent as DeleteIcon } from 'assets/icons/trash.svg';
import { LogicOperatorOptions } from '../utils';

const FieldWrpper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 2rem;

  & > div {
    margin: 0 0.5rem;
  }
`;

const TrashIcon = styled(DeleteIcon)`
  min-width: 1rem;
`;

const TitleInput = styled.input<{ isEqual: boolean }>`
  font-size: 0.875rem;
  border: none;
  border-bottom: 1px solid ${({ isEqual }) => (isEqual ? 'red' : 'black')};
  outline: none;
  width: 40%;
`;

const DeleteWrapper = styled.div`
  margin-left: 1rem;
`;

interface Props {
  equals: string;
  setFieldValue: (field: string, value: any) => void;
  logicOperator: string;
  index: number;
  fieldName: string;
  questionOptions: { name: string; value: string }[];
  remove: (index: number) => void;
}

const LogicOptions = [
  {
    name: 'and',
    value: '&&',
  },
  {
    name: 'or',
    value: '||',
  },
];

const LogicProportionOptions = [
  {
    name: 'or',
    value: '||',
  },
];

const Condition = ({
  equals,
  setFieldValue,
  logicOperator,
  index,
  fieldName,
  questionOptions,
  remove,
}: Props) => {
  const isEqual = !equals;
  const shouldEqualBeDisabled =
    logicOperator === '!empty' || logicOperator === 'empty';
  const isBaseQuestion = index === 0;
  // BE do not support yet && operator in proportions
  const isProportions = fieldName === 'proportions';

  useEffect(() => {
    if (shouldEqualBeDisabled) {
      setFieldValue(`${fieldName}.${index}.equals`, '');
    }
    // eslint-disable-next-line
  }, [logicOperator]);

  if (isBaseQuestion) {
    return (
      <FieldWrpper>
        <Field
          name={`${fieldName}.${index}.question`}
          component={Select}
          options={questionOptions}
          width="40%"
          placeholder="Select Question"
        />
        <Field
          name={`${fieldName}.${index}.logicOperator`}
          component={Select}
          options={
            isProportions
              ? [
                  {
                    name: 'equals',
                    value: '=',
                  },
                ]
              : LogicOperatorOptions
          }
          width="20%"
        />
        <Field
          name={`${fieldName}.${index}.equals`}
          as={TitleInput}
          placeholder="Value"
          isEqual={isEqual && !shouldEqualBeDisabled}
          disabled={shouldEqualBeDisabled}
        />
        <DeleteWrapper>
          <TrashIcon onClick={() => remove(index)} />
        </DeleteWrapper>
      </FieldWrpper>
    );
  }

  return (
    <FieldWrpper key={index}>
      <Field
        name={`${fieldName}.${index}.logic`}
        component={Select}
        options={isProportions ? LogicProportionOptions : LogicOptions}
        width="10%"
      />

      <Field
        name={`${fieldName}.${index}.question`}
        component={Select}
        options={questionOptions}
        width="70%"
        placeholder="Select Question"
      />
      <Field
        name={`${fieldName}.${index}.logicOperator`}
        component={Select}
        options={
          isProportions
            ? [
                {
                  name: 'equals',
                  value: '=',
                },
              ]
            : LogicOperatorOptions
        }
        width="20%"
      />
      <Field
        name={`${fieldName}.${index}.equals`}
        as={TitleInput}
        placeholder="Value"
        isEqual={isEqual && !shouldEqualBeDisabled}
        disabled={shouldEqualBeDisabled}
      />
      <DeleteWrapper>
        <TrashIcon onClick={() => remove(index)} />
      </DeleteWrapper>
    </FieldWrpper>
  );
};

export default Condition;
